import React from "react";

interface AnimationControlsProps {
  onPlay: () => void;
  onPause: () => void;
  onStop: () => void;
  isPlaying?: boolean;
  isPaused?: boolean;
}

const AnimationControls: React.FC<AnimationControlsProps> = ({
  onPlay,
  onPause,
  onStop,
  isPlaying = false,
  isPaused = false,
}) => {
  const handlePlayPause = () => {
    if (isPlaying && !isPaused) {
      onPause();
    } else {
      onPlay();
    }
  };

  return (
    <div className="leaflet-top leaflet-left mb-2 ml-10">
      <div className="leaflet-control leaflet-bar bg-white text-gray-900 p-2 rounded shadow-md flex gap-2">
        <button
          type="button"
          onClick={handlePlayPause}
          className="leaflet-control-button p-1 flex items-center justify-center border-none bg-none cursor-pointer hover:bg-gray-100 rounded"
          aria-label={isPlaying && !isPaused ? "Pause" : "Play"}
        >
          {isPlaying && !isPaused ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect x="6" y="4" width="4" height="16" />
              <rect x="14" y="4" width="4" height="16" />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polygon points="5 3 19 12 5 21 5 3" />
            </svg>
          )}
        </button>

        <button
          type="button"
          onClick={onStop}
          className="leaflet-control-button p-1 flex items-center justify-center border-none bg-none cursor-pointer hover:bg-gray-100 rounded"
          aria-label="Stop"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default AnimationControls;
